import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-contacts-lib',
  template: `
    <p>
      contacts-lib works!
    </p>
  `,
  styles: []
})
export class ContactsLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
